import React from 'react';

import type { RouteMatch } from '@confluence/route';

import { LazyRouteToRightEditor } from '../lazyComponents';
import { getUniquePageLoadId } from '@confluence/unique-page-load-id';

export const EditBlogRoute = ({ params: { contentId, spaceKey } }: RouteMatch) => (
	<LazyRouteToRightEditor contentType="blog" contentId={contentId} spaceKey={spaceKey} />
);

EditBlogRoute.NAVIGATION_PARAMS = ({ params: { contentId, spaceKey } }: RouteMatch) => ({
	Screen: {
		showPremiumOnboarding: false,
		screenEvent: {
			name: 'editPageScreen',
			id: contentId,
			attributes: {
				pageLoadInfo: getUniquePageLoadId(),
			},
		},
		pageState: { contentId, spaceKey, contentType: 'blogpost' },
	},
	MainLayout: false,
});
